
import React from "react";
import { useIntl } from "umi";
import classNames from "classnames";
import { Tag } from "tea-component";
import FilterSelect from "@/pages/dashboard/components/FilterSelect";
import { ISelectorMultipleProps } from "@/pages/dashboard/components/FilterSelect/types";
import './index.scss';

interface ITagFilterSelectProps extends ISelectorMultipleProps {
  buttonText?: string;
  /**
   * 选中项个数 **大于** `maxTags` 时，按钮区只展示选中数量（不展示 Tag）；
   * 不传则始终用 Tag 展示全部选中项。
   */
  maxTags?: number;
}
const TagFilterSelect = (props: ITagFilterSelectProps) => {
  const {
    className,
    overlayClassName,
    placeholder,
    buttonText = '',
    clickClose = false,
    onChange,
    maxTags,
    options = [],
    ...restProps
  } = props || {};
  const { formatMessage, locale } = useIntl();
  return <FilterSelect
    locale={locale}
    options={options}
    className={classNames(`dbl-chart-tag-filter-select`, className)}
    overlayClassName={classNames(`dbl-chart-tag-filter-select-overlay`, overlayClassName)}
    button={(selectedOptions) => {
      const total = selectedOptions?.length || 0;
      const useCountOnly = typeof maxTags === 'number' && maxTags >= 0 && total > maxTags;
      const selectableCount = options?.filter((o) => !o?.disabled).length ?? 0;
      const isSelectAll = selectableCount > 0 && total === selectableCount;
      const useAllOnly = typeof maxTags === 'number' && maxTags >= 0 && isSelectAll;
      let body: React.ReactNode;
      if (!total) {
        body = (
          <div className="dbl-chart-tag-filter-select-placeholder">{placeholder}</div>
        );
      } else if (useCountOnly || useAllOnly) {
        body = (
          <div className="dbl-chart-tag-filter-select-count-only">
            {isSelectAll
              ? formatMessage({ id: 'dbl_common_all' })
              : total}
          </div>
        );
      } else {
        body = (
          <Tag.Group>
            {selectedOptions?.map((o) => (
              <Tag
                key={o?.value}
                onClose={(e) => {
                  e.stopPropagation();
                  const newValue =
                    selectedOptions
                      ?.filter((item) => item?.value !== o?.value)
                      ?.map((v) => v?.value) || [];
                  onChange?.(newValue);
                }}
              >
                {o?.text}
              </Tag>
            ))}
          </Tag.Group>
        );
      }
      return (
        <div className="dbl-chart-tag-filter-select-button">
          <div className="dbl-chart-tag-filter-select-text">{buttonText}</div>
          {body}
        </div>
      );
    }}
    onChange={onChange}
    clickClose={clickClose}
    {...(restProps || {})}
  />;
};

export default TagFilterSelect;